export default __webpack_public_path__ + "static/media/top-quality-image.86c9eb85.png";